module.exports = __webpack_public_path__ + "static/media/bz.81f2d641.svg";